import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PawPrint, Shield, Lightning } from "@phosphor-icons/react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import PackBar from "@/components/PackBar";

const FEATURES = [
  { icon: Shield, title: "Reflective & night-safe", desc: "Silver reflective trim on every bandana, collar and leash so your pit is seen after dark." },
  { icon: PawPrint, title: "Built for pitbulls", desc: "Heavy-duty hardware and sizing made for strong necks and big energy." },
  { icon: Lightning, title: "Hypercolor to match", desc: "Hot-pink & aqua colorways that match the human line — twin up with your dog." },
];

export default function DogGear() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products", { params: { category: "dog-gear" } }).then(({ data }) => setProducts(data)).catch(() => {}); }, []);

  return (
    <div data-testid="doggear-page">
      <section className="relative overflow-hidden grain border-b border-secondary/20">
        <img src="https://static.prod-images.emergentagent.com/jobs/062e260e-b0f9-432f-a759-5890d554bb91/images/0684cefeb14500f3b1b68a8a60eb90c85fc12d2c4e9cd2d24fa37dcae3dd0e44.jpeg" alt="dog gear" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/85 to-background/40" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-28">
          <PawPrint weight="fill" size={32} className="text-secondary mb-5" />
          <p className="overline text-secondary mb-4">Innovative Dog Gear</p>
          <h1 className="text-5xl sm:text-6xl font-modern font-semibold tracking-tighter max-w-2xl leading-[0.92]">Gear that keeps your pit <span className="aqua-text">safe & seen.</span></h1>
          <p className="mt-6 text-muted-foreground max-w-xl leading-relaxed">Reflective hypercolor bandanas, neon collars and matching leashes — designed for pitbull safety at night.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.div key={f.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }}
                className="p-7 rounded-2xl bg-card border border-secondary/20 neon-glow-aqua">
                <Icon weight="duotone" size={26} className="text-secondary mb-4" />
                <h3 className="font-modern text-lg font-medium mb-2">{f.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <PackBar />
        <h2 className="text-3xl font-modern font-semibold tracking-tight mb-8">Shop Dog Gear</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="doggear-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </section>
    </div>
  );
}
